import CustomButton from '@/components/UI/buttons/CustomButton'
import { useAppDispatch } from '@/hooks/redux'
import { clearAuth } from '@/redux/reducers/auth'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

const AuthChangeLicenceIdButton: FC = () => {
    const dispatch = useAppDispatch()

    const { t } = useTranslation()

    const handlePress = () => {
        dispatch(clearAuth())
    }

    return (
        <CustomButton onPress={handlePress} style={{ marginTop: 8 }}>
            {t('deviceAuthorizationScreenChangeLicenceId')}
        </CustomButton>
    )
}

export default AuthChangeLicenceIdButton
